/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../axios';
import { request } from '../../axios';
import type {
  ClinicalReportDto,
  CreateClinicalReportClinicalReportDto,
  CreateClinicalReportDto,
  CreateLabReportDto,
  LabReportDto,
} from '.././model';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const updateLabReport = (
  labReportId: string,
  createLabReportDto: BodyType<CreateLabReportDto>,
  options?: SecondParameter<typeof request>,
) => {
  return request<void>(
    {
      url: `/api/diagnosis/lab-reports/${labReportId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: createLabReportDto,
    },
    options,
  );
};

export const getUpdateLabReportMutationOptions = <
  TData = Awaited<ReturnType<typeof updateLabReport>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { labReportId: string; data: BodyType<CreateLabReportDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updateLabReport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLabReport>>,
    { labReportId: string; data: BodyType<CreateLabReportDto> }
  > = (props) => {
    const { labReportId, data } = props ?? {};

    return updateLabReport(labReportId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { labReportId: string; data: BodyType<CreateLabReportDto> },
    TContext
  >;
};

export type UpdateLabReportMutationResult = NonNullable<Awaited<ReturnType<typeof updateLabReport>>>;
export type UpdateLabReportMutationBody = BodyType<CreateLabReportDto>;
export type UpdateLabReportMutationError = ErrorType<unknown>;

export const useUpdateLabReport = <
  TData = Awaited<ReturnType<typeof updateLabReport>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { labReportId: string; data: BodyType<CreateLabReportDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { labReportId: string; data: BodyType<CreateLabReportDto> }, TContext> => {
  const mutationOptions = getUpdateLabReportMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updateClinicalReport = (
  clinicalReportId: string,
  createClinicalReportClinicalReportDto: BodyType<CreateClinicalReportClinicalReportDto>,
  options?: SecondParameter<typeof request>,
) => {
  return request<void>(
    {
      url: `/api/diagnosis/clinical-report/${clinicalReportId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: createClinicalReportClinicalReportDto,
    },
    options,
  );
};

export const getUpdateClinicalReportMutationOptions = <
  TData = Awaited<ReturnType<typeof updateClinicalReport>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { clinicalReportId: string; data: BodyType<CreateClinicalReportClinicalReportDto> },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updateClinicalReport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClinicalReport>>,
    { clinicalReportId: string; data: BodyType<CreateClinicalReportClinicalReportDto> }
  > = (props) => {
    const { clinicalReportId, data } = props ?? {};

    return updateClinicalReport(clinicalReportId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { clinicalReportId: string; data: BodyType<CreateClinicalReportClinicalReportDto> },
    TContext
  >;
};

export type UpdateClinicalReportMutationResult = NonNullable<Awaited<ReturnType<typeof updateClinicalReport>>>;
export type UpdateClinicalReportMutationBody = BodyType<CreateClinicalReportClinicalReportDto>;
export type UpdateClinicalReportMutationError = ErrorType<unknown>;

export const useUpdateClinicalReport = <
  TData = Awaited<ReturnType<typeof updateClinicalReport>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { clinicalReportId: string; data: BodyType<CreateClinicalReportClinicalReportDto> },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<
  TData,
  TError,
  { clinicalReportId: string; data: BodyType<CreateClinicalReportClinicalReportDto> },
  TContext
> => {
  const mutationOptions = getUpdateClinicalReportMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getLabReportsByPatient = (
  patientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<LabReportDto[]>(
    { url: `/api/diagnosis/patient/${patientId}/lab-reports`, method: 'GET', signal },
    options,
  );
};

export const getGetLabReportsByPatientQueryKey = (patientId: string) => {
  return [`/api/diagnosis/patient/${patientId}/lab-reports`] as const;
};

export const getGetLabReportsByPatientQueryOptions = <
  TData = Awaited<ReturnType<typeof getLabReportsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabReportsByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLabReportsByPatientQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabReportsByPatient>>> = ({ signal }) =>
    getLabReportsByPatient(patientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!patientId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLabReportsByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLabReportsByPatientQueryResult = NonNullable<Awaited<ReturnType<typeof getLabReportsByPatient>>>;
export type GetLabReportsByPatientQueryError = ErrorType<unknown>;

export function useGetLabReportsByPatient<
  TData = Awaited<ReturnType<typeof getLabReportsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabReportsByPatient>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getLabReportsByPatient>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLabReportsByPatient<
  TData = Awaited<ReturnType<typeof getLabReportsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabReportsByPatient>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getLabReportsByPatient>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLabReportsByPatient<
  TData = Awaited<ReturnType<typeof getLabReportsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabReportsByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetLabReportsByPatient<
  TData = Awaited<ReturnType<typeof getLabReportsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabReportsByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLabReportsByPatientQueryOptions(patientId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetLabReportsByPatientSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getLabReportsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLabReportsByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLabReportsByPatientQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabReportsByPatient>>> = ({ signal }) =>
    getLabReportsByPatient(patientId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getLabReportsByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLabReportsByPatientSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLabReportsByPatient>>>;
export type GetLabReportsByPatientSuspenseQueryError = ErrorType<unknown>;

export function useGetLabReportsByPatientSuspense<
  TData = Awaited<ReturnType<typeof getLabReportsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLabReportsByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLabReportsByPatientSuspense<
  TData = Awaited<ReturnType<typeof getLabReportsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLabReportsByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLabReportsByPatientSuspense<
  TData = Awaited<ReturnType<typeof getLabReportsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLabReportsByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetLabReportsByPatientSuspense<
  TData = Awaited<ReturnType<typeof getLabReportsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLabReportsByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLabReportsByPatientSuspenseQueryOptions(patientId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createLabReportByPatient = (
  patientId: string,
  createLabReportDto: BodyType<CreateLabReportDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/diagnosis/patient/${patientId}/lab-reports`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createLabReportDto,
      signal,
    },
    options,
  );
};

export const getCreateLabReportByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof createLabReportByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { patientId: string; data: BodyType<CreateLabReportDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createLabReportByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLabReportByPatient>>,
    { patientId: string; data: BodyType<CreateLabReportDto> }
  > = (props) => {
    const { patientId, data } = props ?? {};

    return createLabReportByPatient(patientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { patientId: string; data: BodyType<CreateLabReportDto> },
    TContext
  >;
};

export type CreateLabReportByPatientMutationResult = NonNullable<Awaited<ReturnType<typeof createLabReportByPatient>>>;
export type CreateLabReportByPatientMutationBody = BodyType<CreateLabReportDto>;
export type CreateLabReportByPatientMutationError = ErrorType<unknown>;

export const useCreateLabReportByPatient = <
  TData = Awaited<ReturnType<typeof createLabReportByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { patientId: string; data: BodyType<CreateLabReportDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { patientId: string; data: BodyType<CreateLabReportDto> }, TContext> => {
  const mutationOptions = getCreateLabReportByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getClinicalReportByPatient = (
  patientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<ClinicalReportDto>(
    { url: `/api/diagnosis/patient/${patientId}/clinical-report`, method: 'GET', signal },
    options,
  );
};

export const getGetClinicalReportByPatientQueryKey = (patientId: string) => {
  return [`/api/diagnosis/patient/${patientId}/clinical-report`] as const;
};

export const getGetClinicalReportByPatientQueryOptions = <
  TData = Awaited<ReturnType<typeof getClinicalReportByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClinicalReportByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClinicalReportByPatientQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClinicalReportByPatient>>> = ({ signal }) =>
    getClinicalReportByPatient(patientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!patientId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClinicalReportByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClinicalReportByPatientQueryResult = NonNullable<Awaited<ReturnType<typeof getClinicalReportByPatient>>>;
export type GetClinicalReportByPatientQueryError = ErrorType<unknown>;

export function useGetClinicalReportByPatient<
  TData = Awaited<ReturnType<typeof getClinicalReportByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClinicalReportByPatient>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getClinicalReportByPatient>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClinicalReportByPatient<
  TData = Awaited<ReturnType<typeof getClinicalReportByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClinicalReportByPatient>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getClinicalReportByPatient>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClinicalReportByPatient<
  TData = Awaited<ReturnType<typeof getClinicalReportByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClinicalReportByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetClinicalReportByPatient<
  TData = Awaited<ReturnType<typeof getClinicalReportByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClinicalReportByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClinicalReportByPatientQueryOptions(patientId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClinicalReportByPatientSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClinicalReportByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClinicalReportByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClinicalReportByPatientQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClinicalReportByPatient>>> = ({ signal }) =>
    getClinicalReportByPatient(patientId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClinicalReportByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClinicalReportByPatientSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClinicalReportByPatient>>
>;
export type GetClinicalReportByPatientSuspenseQueryError = ErrorType<unknown>;

export function useGetClinicalReportByPatientSuspense<
  TData = Awaited<ReturnType<typeof getClinicalReportByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClinicalReportByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClinicalReportByPatientSuspense<
  TData = Awaited<ReturnType<typeof getClinicalReportByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClinicalReportByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClinicalReportByPatientSuspense<
  TData = Awaited<ReturnType<typeof getClinicalReportByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClinicalReportByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetClinicalReportByPatientSuspense<
  TData = Awaited<ReturnType<typeof getClinicalReportByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClinicalReportByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClinicalReportByPatientSuspenseQueryOptions(patientId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createClinicalReportByPatient = (
  patientId: string,
  createClinicalReportDto: BodyType<CreateClinicalReportDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/diagnosis/patient/${patientId}/clinical-report`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createClinicalReportDto,
      signal,
    },
    options,
  );
};

export const getCreateClinicalReportByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof createClinicalReportByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { patientId: string; data: BodyType<CreateClinicalReportDto> },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createClinicalReportByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClinicalReportByPatient>>,
    { patientId: string; data: BodyType<CreateClinicalReportDto> }
  > = (props) => {
    const { patientId, data } = props ?? {};

    return createClinicalReportByPatient(patientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { patientId: string; data: BodyType<CreateClinicalReportDto> },
    TContext
  >;
};

export type CreateClinicalReportByPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClinicalReportByPatient>>
>;
export type CreateClinicalReportByPatientMutationBody = BodyType<CreateClinicalReportDto>;
export type CreateClinicalReportByPatientMutationError = ErrorType<unknown>;

export const useCreateClinicalReportByPatient = <
  TData = Awaited<ReturnType<typeof createClinicalReportByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { patientId: string; data: BodyType<CreateClinicalReportDto> },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { patientId: string; data: BodyType<CreateClinicalReportDto> }, TContext> => {
  const mutationOptions = getCreateClinicalReportByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const deleteLabReport = (id: string, options?: SecondParameter<typeof request>) => {
  return request<void>({ url: `/api/diagnosis/lab-report/${id}`, method: 'DELETE' }, options);
};

export const getDeleteLabReportMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteLabReport>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['deleteLabReport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLabReport>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return deleteLabReport(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { id: string }, TContext>;
};

export type DeleteLabReportMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLabReport>>>;

export type DeleteLabReportMutationError = ErrorType<unknown>;

export const useDeleteLabReport = <
  TData = Awaited<ReturnType<typeof deleteLabReport>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string }, TContext> => {
  const mutationOptions = getDeleteLabReportMutationOptions(options);

  return useMutation(mutationOptions);
};
export const deleteClinicalReport = (id: string, options?: SecondParameter<typeof request>) => {
  return request<void>({ url: `/api/diagnosis/clinical-report/${id}`, method: 'DELETE' }, options);
};

export const getDeleteClinicalReportMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteClinicalReport>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['deleteClinicalReport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClinicalReport>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return deleteClinicalReport(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { id: string }, TContext>;
};

export type DeleteClinicalReportMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClinicalReport>>>;

export type DeleteClinicalReportMutationError = ErrorType<unknown>;

export const useDeleteClinicalReport = <
  TData = Awaited<ReturnType<typeof deleteClinicalReport>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string }, TContext> => {
  const mutationOptions = getDeleteClinicalReportMutationOptions(options);

  return useMutation(mutationOptions);
};
